<div class="container-fluid">


  <header [ngClass]="theme.getThemeClass()">
    <nav  [ngClass]="theme.getThemeClass()" class="navbar navbar-expand-lg navbar-light bg-light tabs">
      <div  [ngClass]="theme.getThemeClass()" class="navbar-nav flex-nowrap" id="navbarNavAltMarkup">
        <a class="nav-item nav-link" href="javascript:void(0)" (click)="devicesClicked()" [ngClass]="{ 'active' : mainContent === 'devices' }">
          {{ 'iotNavButtonDevices' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" (click)="technicalClicked()" [ngClass]="{ 'active' : mainContent === 'technical' }">
          {{ 'technical' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" (click)="reportsClicked()" [ngClass]="{ 'active' : mainContent === 'reports' }">
          {{ 'iotNavButtonReports' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" (click)="shadowFeedClicked()" [ngClass]="{ 'active' : mainContent === 'feed' }">
          {{ 'shadow' | translate }}
        </a>
        <a class="nav-item nav-link" href="javascript:void(0)" (click)="devicesLocationClicked()" [ngClass]="{ 'active' : mainContent === 'devices-location' }">
          {{ 'binListViewLocation' | translate }}
        </a>
      </div>
    </nav>
  </header>

  @if (mainContent === 'devices') {
    <app-iot-devices-filters></app-iot-devices-filters>
    <app-iot-devices-table></app-iot-devices-table>
  }

  @if (mainContent === 'technical') {
    <app-iot-devices-filters></app-iot-devices-filters>
    <app-iot-technical-table></app-iot-technical-table>
  }

  <app-iot-reports-view [hidden]="mainContent !== 'reports'"></app-iot-reports-view>

  @if (mainContent === 'feed') {
    <app-iot-shadow-feed></app-iot-shadow-feed>
  }

  @if (mainContent === 'devices-location') {
    <app-iot-devices-filters></app-iot-devices-filters>
    <app-iot-devices-location></app-iot-devices-location>
  }

  @if (iotService.showDeviceConfigModal) {
    <div class="modal-overlay">
      <app-device-modal-config
        class="appDeviceConfigModal"
        (deviceGroupChangeEvent)="onDeviceGroupChange($event)"
      ></app-device-modal-config>
    </div>
  }
  @if (modal.showDeviceModal) {
    <div class="modal-overlay">
      <app-device-modal class="appDeviceModal"></app-device-modal>
    </div>
  }
  @if (iotService.showDeviceTechnicalGraphs) {
    <div class="modal-overlay">
      <app-device-modal-graphs class="appDeviceTechnicalGraphs"></app-device-modal-graphs>
    </div>
  }
</div>

<!-- <div id="canvas-holder" style="overflow-y: auto;">
  <canvas id="tonnageCanvas" #tonnageCanvas></canvas>
  <canvas id="usageCanvas" #usageCanvas></canvas>
  <canvas id="marketCanvas" #marketCanvas></canvas>
  <canvas id="countCanvas" #countCanvas></canvas>
  <canvas id="marketTonnageCanvas" #marketTonnageCanvas></canvas>
  <canvas id="usageTonnageCanvas" #usageTonnageCanvas></canvas>
  <canvas id="subgroupTonnageCanvas" #subgroupTonnageCanvas></canvas>
</div> -->
